/** Hourly visit slots — must match Laravel UserAvailabilityController::TIME_SLOTS. */
export const AM_TIME_SLOTS = [
  "12:00 AM",
  "01:00 AM",
  "02:00 AM",
  "03:00 AM",
  "04:00 AM",
  "05:00 AM",
  "06:00 AM",
  "07:00 AM",
  "08:00 AM",
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
];

export const PM_TIME_SLOTS = [
  "12:00 PM",
  "01:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
  "05:00 PM",
  "06:00 PM",
  "07:00 PM",
  "08:00 PM",
  "09:00 PM",
  "10:00 PM",
  "11:00 PM",
];

export const ALL_TIME_SLOTS = [...AM_TIME_SLOTS, ...PM_TIME_SLOTS];
